import type { ReactNode } from 'react';

import classNames from 'classnames';

import type { TicketListItemType} from './TicketsListItem';
import { TicketsListItem } from './TicketsListItem';

type Props = {
  tickets: TicketListItemType[];
  isLoading?: boolean;
  className?: string;
  title?: string;
  showWinText?: boolean;
  extraBottom?: ReactNode;
};

export const TicketsList = ({
  tickets,
  className,
  title,
  showWinText = true,
  extraBottom,
}: Props) => {
  const entriesList = tickets.map((entry) => (
    <TicketsListItem
      key={entry.code}
      code={entry.code}
      isWinner={entry.isWinner}
      showWinText={showWinText}
      extraBottom={extraBottom}
    />
  ));

  return (
    <div className={classNames('flex flex-col gap-1.5', className)}>
      {title ? (
        <div className="text-caption-sm-strong-a text-base-text-primary">{title}</div>
      ) : null}
      <div className={classNames('flex flex-col')}>{entriesList}</div>
    </div>
  );
};
